import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ExamInForm } from './edit-exam-in-form-dialog';

interface SelectedExamsListProps {
  examsInForm: Map<number, ExamInForm>;
  onEditExam: (examId: number) => void;
  onAddExam: () => void;
}

export const SelectedExamsList: React.FC<SelectedExamsListProps> = ({
  examsInForm,
  onEditExam,
  onAddExam,
}) => {
  if (examsInForm.size === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: '16px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <label
          style={{
            fontSize: '14px',
            color: '#4b5563',
            fontWeight: 'bold',
          }}
        >
          הגדרות מבחנים נבחרים
        </label>
        <Button
          icon="pi pi-plus"
          label="הוספת מבחן"
          onClick={onAddExam}
          style={{ height: '30px', fontSize: '14px' }}
        />
      </div>
      <DataTable
        value={Array.from(examsInForm.values())}
        dataKey="externalExam.id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '8px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          header="שם מבחן"
          body={(rowData: ExamInForm) => (
            <div>{rowData.externalExam.examName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="תאריך התחלה"
          body={(rowData: ExamInForm) => (
            <div>
              {rowData.startAt
                ? new Date(rowData.startAt).toLocaleDateString('he-IL')
                : 'לא נבחר'}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="משך (דקות)"
          body={(rowData: ExamInForm) => <div>{rowData.durationMinutes}</div>}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="תאריך אחרון לרישום"
          body={(rowData: ExamInForm) => (
            <div>
              {rowData.studentRegistrationDueDate
                ? new Date(
                    rowData.studentRegistrationDueDate,
                  ).toLocaleDateString('he-IL')
                : 'לא נבחר'}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          header="פעולות"
          body={(rowData: ExamInForm) => (
            <Button
              icon="pi pi-pencil"
              text
              severity="warning"
              tooltip={'עריכת הגדרות מבחן'}
              onClick={() => onEditExam(rowData.externalExam.id)}
            />
          )}
        />
      </DataTable>
    </div>
  );
};
